import { useMemo } from 'react';
import { Box, Button } from '@mui/material';
import { useFieldHelper } from 'framework/ui/field';
import { ACCESS_INFO_ACTIONS, ACCESS_INFO_SECTIONS, useProjectSecurityContext } from 'domain/shared/newProject';
import { ASSUMPTION_EXCEPTION_STATUS, ASSUMPTION_STATUS, AssumptionType } from '../../types';
import { useAssumptionActions } from '../../CreateAndUpdateAssumption/AssumptionActionsProvider';

const ReviewActionField = () => {
  const { getData } = useFieldHelper<unknown>({ source: 'id' });
  const { isAccessGranted } = useProjectSecurityContext();
  const { openReview, openConfirm } = useAssumptionActions();
  const row = getData() as AssumptionType | undefined;

  const canReview = isAccessGranted(ACCESS_INFO_SECTIONS.ASSUMPTION, ACCESS_INFO_ACTIONS.REVIEW);
  const canConfirm =
    isAccessGranted(ACCESS_INFO_SECTIONS.ASSUMPTION, ACCESS_INFO_ACTIONS.MANAGE) ||
    isAccessGranted(ACCESS_INFO_SECTIONS.ASSUMPTION, ACCESS_INFO_ACTIONS.PARTIAL_MANAGE);

  const action = useMemo(() => {
    if (!row || row.status === ASSUMPTION_STATUS.INACTIVE) return null;
    if (canReview && row.exceptionStatus === ASSUMPTION_EXCEPTION_STATUS.PENDING) {
      return { label: 'Review', onClick: () => openReview(row) };
    }
    if (canConfirm && row.isVerificationRequired) {
      return { label: 'Confirm', onClick: () => openConfirm(row) };
    }
    return null;
  }, [row, canReview, canConfirm, openReview, openConfirm]);

  if (!action) return <Box sx={{ width: '100%' }} />;

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 0.5, width: '100%' }}>
      <Button variant="text" size="small" onClick={action.onClick}>
        {action.label}
      </Button>
    </Box>
  );
};

export default ReviewActionField;
